// export type Env = 'prod' | 'uat' | 'dev';

export const PUBLIC_IMG_URL = 'https://ecocart-public-images.s3.amazonaws.com';
export const DEFAULT_SHOP_LOGO =
  'https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://ecocart.io&size=32';
export const DEFAULT_AVATAR = 'https://avatars.dicebear.com/v2/female/b4713285457d255c6e85c2681d8b1d6b.svg';
export const PRODUCT_FRUITS_CHECKLIST_ID = 2064;
export const PRODUCT_FRUITS_SURVEY_ID = '698d7907-d7de-4946-9e26-9d8bd67d57f8';
